import { useEffect, useRef } from 'react';

export const useFormNavigation = (isActive = true) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isActive || !containerRef.current) return;

    const container = containerRef.current;

    // सिर्फ इनपुट, सेलेक्ट और 'submit-btn' क्लास वाले बटन को ही पकड़ेगा
    const focusableSelector = 'input:not([disabled]):not([type="hidden"]):not([readOnly]), select:not([disabled]), textarea:not([disabled]), .ant-select-selection-search-input, button.submit-btn';
    
    // फॉर्म खुलते ही पहले फील्ड पर फोकस
    setTimeout(() => {
      const firstElement = container.querySelector(focusableSelector);
      if (firstElement) firstElement.focus();
    }, 300);

    const handleKeyDown = (e) => {
      const activeEl = document.activeElement;

      // --- ENTER KEY LOGIC ---
      if (e.key === 'Enter') {
        // Textarea (Remarks) में Enter से नई लाइन बनेगी
        if (activeEl.tagName.toLowerCase() === 'textarea') return;

        const isDropdownOpen = activeEl.getAttribute('aria-expanded') === 'true';

        // इस फॉर्म के अंदर के सभी एक्टिव इनपुट्स की लिस्ट अभी बना लें
        const formElements = Array.from(container.querySelectorAll(focusableSelector))
          .filter(el => el.offsetWidth > 0 || el.offsetHeight > 0);
        
        const currentIndex = formElements.indexOf(activeEl);

        // 🟢 अगर Dropdown खुला है (नया लॉजिक)
        if (isDropdownOpen) {
          // Ant Design को आइटम सेलेक्ट करने दें, और 100ms बाद अपने-आप अगले फील्ड पर जाएं
          setTimeout(() => {
            const freshElements = Array.from(container.querySelectorAll(focusableSelector))
              .filter(el => el.offsetWidth > 0 || el.offsetHeight > 0);

            if (currentIndex > -1 && currentIndex < freshElements.length - 1) {
              freshElements[currentIndex + 1].focus(); // अगले इनपुट पर जंप
            } 
            else if (currentIndex === freshElements.length - 1) {
              if (freshElements[currentIndex].classList.contains('submit-btn')) {
                freshElements[currentIndex].click(); // सेव बटन पर क्लिक
              }
            }
          }, 100);
          
          return; // यहाँ preventDefault नहीं लगाएंगे ताकि ड्रॉपडाउन काम कर सके
        }

        // 🔵 नॉर्मल Enter का लॉजिक (जब कोई ड्रॉपडाउन खुला न हो)
        e.preventDefault();

        if (currentIndex > -1 && currentIndex < formElements.length - 1) {
          formElements[currentIndex + 1].focus(); // अगले इनपुट पर जंप
        } 
        else if (currentIndex === formElements.length - 1) {
          if (formElements[currentIndex].classList.contains('submit-btn')) {
            formElements[currentIndex].click(); // सेव बटन पर क्लिक
          }
        }
      }

      // --- DOWN ARROW LOGIC (Dropdown खोलने के लिए) ---
      if (e.key === 'ArrowDown') {
        if (activeEl.classList.contains('ant-select-selection-search-input')) {
          if (activeEl.getAttribute('aria-expanded') !== 'true') {
            activeEl.click();
          }
        }
      }
    };

    container.addEventListener('keydown', handleKeyDown);
    return () => container.removeEventListener('keydown', handleKeyDown);
  }, [isActive]);

  return containerRef;
};